<p-card header="Deine Motivation*">
  <div class="flex flex-col gap-2">
    <p>
      Du bist interessant für uns! Wir freuen uns zu erfahren, warum du dich für eine Vertriebspartnerschaft interessierst und warum du dich für eine
      Bewerbung bei TauRes entschieden hast. Alternativ kannst du dein Motivationsschreiben unter "Deine Dokumente" hochladen.
    </p>
    <p-fluid>
      <textarea pTextarea [formControl]="motivation" rows="8"></textarea>
      <div class="flex justify-between items-start">
        <div>
          @if (motivation.hasError('minlength')) {
            <span class="form-hint-text-error"> Mindestens {{ motivation.errors?.['minlength']?.requiredLength }} Zeichen eingeben. </span>
          }
        </div>
        <small [ngClass]="motivation.errors && this.motivation.errors['maxlength'] ? 'form-hint-text-error' : 'form-hint-text'">
          {{ motivation.value?.length ?? 0 }}/{{ motivationMaxLength }}
        </small>
      </div>
    </p-fluid>
  </div>
</p-card>
